import { render, staticRenderFns } from "./CommunityNavbarActions.vue?vue&type=template&id=3bfd8d37&"
import script from "./CommunityNavbarActions.vue?vue&type=script&lang=js&"
export * from "./CommunityNavbarActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports